import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/Auth/LoginForm';
import { useAuth } from '../contexts/AuthContext';

const AuthPage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { login, isAuthenticated } = useAuth();

  // Redirect to dashboard if already authenticated
  useEffect(() => {
    console.log('🔍 AuthPage: isAuthenticated =', isAuthenticated);
    if (isAuthenticated) {
      console.log('✅ AuthPage: Redirecting to dashboard');
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async (email: string, password: string) => {
    setLoading(true);
    setError(null);
    console.log('🔐 AuthPage: Starting login for:', email);
    
    try {
      await login(email, password);
      console.log('✅ AuthPage: Login successful, navigating to dashboard');
      // Navigate to dashboard after successful login
      navigate('/dashboard');
    } catch (err: any) {
      console.error('❌ AuthPage: Login error:', err);
      setError(
        err.response?.data?.message || 
        err.message || 
        'Login failed. Please check your credentials and try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  const switchToRegister = () => {
    // Redirect to new self-service signup page
    navigate('/signup');
  };

  return (
    <LoginForm
      onLogin={handleLogin}
      onSwitchToRegister={switchToRegister}
      loading={loading}
      error={error}
    />
  );
};

export default AuthPage;